import { PrimeNgModule, PrimeNgProviders } from './primeng-modules';
import { LoadingComponent } from '../components/loading/loading.component';
import { CustomHeader } from '../components/customHeader';
import { WINDOW_PROVIDERS } from '../windowprovider';
import { AutoCompleteComponent } from '../autoComplete';
import { SetCustomColorComponent } from '../setCustomColor';
import { SearchGeAssessmentsHeader } from '../searchGeAssessmentsHeader';
import { ManageCropModalHeaderComponent } from '../cropManageHeader';
import { ReportModalHeaderComponent } from '../reportModalHeader';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { InventorLeEditorComponent } from '../inventorLeEditorComponent';
import { AgGridModule } from 'ag-grid-angular';
import { MultiSelectComponent } from '../multiSelectComponent';
import { NgSelectModule } from '@ng-select/ng-select';
import { ManageProgramModalHeaderComponent } from '../programManageHeader';
import { InvalidCountComponent } from '../invalidCountComponent';

@NgModule({
    imports: [PrimeNgModule, BrowserAnimationsModule, BrowserModule, FormsModule, AgGridModule, NgSelectModule],
    declarations:[
        LoadingComponent,
        CustomHeader,
        AutoCompleteComponent,
        MultiSelectComponent,
        SetCustomColorComponent,
        SearchGeAssessmentsHeader,
        ManageCropModalHeaderComponent,
        ManageProgramModalHeaderComponent,
        ReportModalHeaderComponent,
        InventorLeEditorComponent,
        InvalidCountComponent
    ],
    exports:[PrimeNgModule, LoadingComponent],
    providers:[WINDOW_PROVIDERS, PrimeNgProviders]
    
})
export class SharedModule {}